import { render, staticRenderFns } from "./EditResellerPaymentComponent.vue?vue&type=template&id=066f730a&"
import script from "./EditResellerPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./EditResellerPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports